import React, { useEffect } from 'react';
import { Button, Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelfService } from '../../hooks/useSelfService';
import { PayrollEntry, PayrollStatus } from '../../types';

const STATUS_COLOR: Record<PayrollStatus, string> = {
  DRAFT: 'default',
  PENDING_APPROVAL: 'gold',
  APPROVED: 'blue',
  PROCESSED: 'cyan',
  PAID: 'green',
  CANCELLED: 'red',
};

const SelfServicePayslipsView: React.FC = () => {
  const navigate = useNavigate();
  const { payslips, loading, fetchMyPayslips } = useSelfService();

  useEffect(() => {
    fetchMyPayslips();
  }, []);

  const columns = [
    { title: 'Period', dataIndex: 'payrollPeriodName', key: 'period' },
    {
      title: 'Gross Pay', dataIndex: 'grossPay', key: 'grossPay',
      render: (v: number) => v?.toLocaleString('en-US', { minimumFractionDigits: 2 }),
    },
    {
      title: 'Total Deductions', dataIndex: 'totalDeductions', key: 'totalDeductions',
      render: (v: number) => v?.toLocaleString('en-US', { minimumFractionDigits: 2 }),
    },
    {
      title: 'Net Pay', dataIndex: 'netPay', key: 'netPay',
      render: (v: number) => <strong>{v?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>,
    },
    {
      title: 'Status', dataIndex: 'status', key: 'status',
      render: (s: PayrollStatus) => <Tag color={STATUS_COLOR[s]}>{s?.replace('_', ' ')}</Tag>,
    },
    { title: 'Paid Date', dataIndex: 'paidDate', key: 'paidDate' },
    {
      title: '', key: 'action',
      render: (_: unknown, record: PayrollEntry) => (
        <Button type="link" onClick={() => navigate(`/hr/self-service/payslips/${record.id}`)}>View</Button>
      ),
    },
  ];

  return (
    <div className="p-6">
      <Card title="My Payslips">
        <Table
          dataSource={payslips}
          columns={columns}
          rowKey="id"
          size="small"
          loading={loading}
          onRow={(record) => ({ onClick: () => navigate(`/hr/self-service/payslips/${record.id}`) })}
          style={{ cursor: 'pointer' }}
        />
      </Card>
    </div>
  );
};

export default SelfServicePayslipsView;
